import React, { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import { MdClose } from "react-icons/md";
import {
    FaRegCalendar,
} from "react-icons/fa";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import moment from "moment";
import Images from "../../Images";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { capitalizeFirstLetter, paymentModes } from "../../helpers";
import ModalProfileHeader from "../Common/ModalProfileHeader";
// import { newDate } from "react-datepicker/dist/date_utils";

const OfflineRefundModal = ({
    setShowOfflineRefundModal,
    returnDepositMutate,
    returnDepositLoading,
    isEvicted,
    data,
    finalDueRefund
}) => {

    const [calendarOpen, setCalendarOpen] = useState(false);
    const formikRef = useRef(null);
    const today = moment().format("YYYY-MM-DD");

    const [height, setHeight] = useState(window.innerHeight);


    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initialValues = {
        tenantid: data?.tenantId,
        returnDate: "",
        paymentMode: "",
        amount: Math.abs(finalDueRefund) || Math.abs(data?.refundAmount) || data?.excessBalance,
    };

    const handleSubmit = (values, formikHelpers) => {
        if (!values.returnDate) {
            toast.error("Date is required");
            return;
        }

        if (
            values.paymentMode === undefined ||
            values.paymentMode === null ||
            !values.paymentMode
        ) {
            toast.error("Payment mode is required");
            return;
        }

        //let newTime = values.returnDate + " " + moment().format("HH:mm:ss");
        const paidDate = moment(
            `${values.returnDate} ${moment().format("HH:mm:ss")}`,
            "DD-MM-YYYY HH:mm:ss",
            true
        );
        if (!paidDate.isValid()) {
            toast.error("Invalid return date");
            return;
        }

        returnDepositMutate({
            //returnDate: moment(values.returnDate).utc().format(),
            // paidDate: moment(newTime).utc().format(),
            paidDate: paidDate.utc().format(),
            mode: values.paymentMode,
            tenantId: data?.tenantId,
            amount: Math.abs(finalDueRefund) || Math.abs(data?.refundAmount) || data?.excessBalance,
        });
        //formikHelpers.resetForm();
    };

    const handleClose = () => {
        setShowOfflineRefundModal(false);
    };

    return (
        <Container
            style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}
        >
            <Header>
                <h1 className="text-white text-lg font-medium">Make Refund</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ModalProfileHeader
                title="Due Details"
                name={capitalizeFirstLetter(data?.tenantName)}
                subtitle={`#${data?.propAddress}`}
                amountLabel={"Refund Amount"}
                amount={data?.refundAmount}
                image={data?.selfi}
                onClose={() => setShowOfflineRefundModal(false)}
            />

            <div className="px-4 flex flex-col justify-between" >
                <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                    {({ setFieldValue, values, resetForm }) => (
                        <Form>
                            {/* <ScrollableContent className="!max-h-[calc(100dvh-140px)]"> */}
                            <Wrapper>
                                <InputGroup>
                                    <Label htmlFor="returnDate">Return Date *</Label>
                                    <FieldWrappers className="relative w-full">
                                        <DatePicker
                                            //selected={values.returnDate ? new Date(values.returnDate) : null}
                                            selected={values.returnDate ? moment(values.returnDate, "DD-MM-YYYY").toDate() : null}
                                            onChange={(date) =>
                                                setFieldValue("returnDate", moment(date).format("DD-MM-YYYY"))
                                            }
                                            maxDate={new Date()}
                                            dateFormat="dd-MM-yyyy"
                                            className="cursor-pointer"
                                            placeholderText="DD-MM-YYYY"
                                            onClickOutside={() => setCalendarOpen(false)}
                                            onSelect={() => setCalendarOpen(false)}
                                            open={calendarOpen}
                                            onInputClick={() => setCalendarOpen(true)}
                                            popperPlacement="top-end"
                                            showIcon
                                            icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                            showPopperArrow={false}
                                            onFocus={(e) => e.target.blur()}
                                            wrapperClassName="w-full"
                                            portalId="root-portal"
                                            popperClassName="react-datepicker-popper"
                                        />
                                        {/* <CalendarIcon /> */}
                                    </FieldWrappers>

                                </InputGroup>

                                <InputGroup>
                                    <Label>Payment Mode *</Label>
                                    <PaymentModeWrapper>
                                        {paymentModes.map((mode) => (
                                            <PaymentModeCard
                                                key={mode.value}
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFieldValue("paymentMode", mode.value, false);
                                                }}
                                                className={
                                                    values.paymentMode === mode.value
                                                        ? "bg-blue-100 border-blue-500"
                                                        : "bg-gray-100"
                                                }
                                            >
                                                {/* {mode.icon} */}
                                                <span className="text-sm">{mode.label}</span>
                                            </PaymentModeCard>
                                        ))}
                                    </PaymentModeWrapper>
                                </InputGroup>


                            </Wrapper>
                            {/* </ScrollableContent> */}
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={() => {
                                    resetForm();
                                    handleClose();
                                }
                                }>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={returnDepositLoading}>
                                    {returnDepositLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>

            </div>
        </Container>
    );
};

const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`;
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative `;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const OptionCard = tw.div`
  flex flex-col items-center justify-center p-3 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isselected === "true"
            ? "bg-primary-color/10 border-primary-color"
            : "bg-white hover:bg-gray-50"}
`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
export default OfflineRefundModal;

